<template>
  <div class="lenovoMaterial">
    <el-table stripe :data="tableData" border style="width: 100%" height="100%" size="mini">
      <el-table-column type="index" :width="pagination.endIndex >= 1000 ? 80 : 50"
        align="center" :index="pagination.beginIndex"
      ></el-table-column>
      <el-table-column prop="mtm" label="MTM" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.mtm || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="partSnPrefix" label="SN前缀" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.partSnPrefix || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="lenovoPartNumber" label="联想料号" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <span>{{ scope.row.lenovoPartNumber || '-' }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="customerSupplied" label="10位长码" align="center">
        <template slot-scope="scope">
          <span :style="{ color: scope.row.customerSupplied ? '#67C23A' : '#F56C6C' }">
            {{ scope.row.customerSupplied ? '是' : '否' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="120px">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top" :open-delay="300">
            <i @click="handleEdit(scope.row)" class="el-icon-edit" style="cursor: pointer;"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :pagination="pagination"
      @currentChange="currentChange"
      @sizeChange="sizeChange"
      @refreshBtn="onSearch"
    ></pagination>
    <myDialog
      ref="myDialog"
      :title="dialogTitle"
      @submitData="submitData"
      @dialogClose="dialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="dialogForm"
          :model="dialogForm"
          :rules="dialogRules"
          :label-width="labelWidth"
        >
          <el-form-item label="SN前缀：" size="small" prop="partSnPrefix">
            <el-input v-model="dialogForm.partSnPrefix" placeholder="输入配件SN前缀" clearable></el-input>
          </el-form-item>
          <el-form-item label="联想料号：" size="small" prop="lenovoPartNumber">
            <el-input v-model="dialogForm.lenovoPartNumber" placeholder="输入联想料号" clearable></el-input>
          </el-form-item>
          <el-form-item label="MTM：" size="small" prop="mtm">
            <el-input v-model="dialogForm.mtm" placeholder="输入客户成品料号" clearable></el-input>
          </el-form-item>
          <el-form-item label="10位长码：" size="small" prop="customerSupplied">
            <el-radio-group v-model="dialogForm.customerSupplied">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
    <myDialog
      ref="copyDialog"
      :title="copyDialogTitle"
      @submitData="submitCopyData"
      @dialogClose="copyDialogClose"
      width="450px"
    >
      <template slot="content">
        <el-form
          ref="copyForm"
          :model="copyForm"
          :rules="copyRules"
          :label-width="labelWidth"
        >
          <el-form-item label="源MTM：" size="small" prop="sourceMtm">
            <el-input v-model="copyForm.sourceMtm" placeholder="输入源MTM" clearable></el-input>
          </el-form-item>
          <el-form-item label="新MTM：" size="small" prop="targetMtm">
            <el-input v-model="copyForm.targetMtm" placeholder="输入新MTM" clearable></el-input>
          </el-form-item>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import myDialog from "@/components/myDialog.vue";
import {
  apiLenovoMaterialSearch,
  apiLenovoMaterialAdd,
  apiLenovoMaterialUpdate,
  apiLenovoMaterialCopy,
  apiLenovoMaterialDelete,
  apiLenovoMaterialExport,
} from "@/api/itemCodeManage.js";
export default {
  components: {
    pagination,
    myDialog,
  },
  props: {
    lenovoSearchForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 0,
        beginIndex: 1,
        endIndex: 10,
      },
      dialogTitle: "",
      dialogForm: {},
      copyDialogTitle: "",
      copyForm: {},
      copyRules: {
        sourceMtm: [
          { required: true, message: "源MTM不能为空！", trigger: "blur" },
        ],
        targetMtm: [
          { required: true, message: "新MTM不能为空！", trigger: "blur" },
        ],
      },
      dialogRules: {
        partSnPrefix: [
          { required: true, message: "配件SN前缀不能为空！", trigger: "blur" },
        ],
        lenovoPartNumber: [
          { required: true, message: "联想料号不能为空！", trigger: "blur" },
        ],
        mtm: [
          { required: true, message: "客户成品料号不能为空！", trigger: "blur" },
        ],
        customerSupplied: [
          { required: true, message: "请选择10位长码！", trigger: "change" },
        ],
      },
      labelWidth: "110px",
    };
  },
  methods: {
    // 表格数据
    async onSearch() {
      this.tableData = [];
      const res = await apiLenovoMaterialSearch({
        ...this.lenovoSearchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
      });
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
      }
    },
    // 新建
    addNew() {
      this.dialogTitle = "新建联想物料编码";
      this.dialogForm = {};
      this.$refs.myDialog.dialogVisible = true;
    },
    // 复制
    copyNew() {
      this.copyDialogTitle = "复制联想物料编码";
      this.copyForm = {};
      this.$refs.copyDialog.dialogVisible = true;
    },
    // 修改
    handleEdit(row) {
      this.dialogTitle = "修改联想物料编码";
      this.dialogForm = {
        id: row.id,
        partSnPrefix: row.partSnPrefix,
        lenovoPartNumber: row.lenovoPartNumber,
        mtm: row.mtm,
        customerSupplied: row.customerSupplied,
      };
      this.$refs.myDialog.dialogVisible = true;
    },
    // 确认新建/修改
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          if (title == "新建联想物料编码") {
            const res = await apiLenovoMaterialAdd({
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.onSearch();
              this.$message({ message: "新建成功", type: "success" });
            }
          } else if (title == "修改联想物料编码") {
            const res = await apiLenovoMaterialUpdate({
              ...this.dialogForm,
            });
            if (res.code == 0) {
              this.$refs.myDialog.dialogVisible = false;
              this.onSearch();
              this.$message({ message: "修改成功", type: "success" });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
    },
    // 确认复制
    submitCopyData(title) {
      this.$refs.copyForm.validate(async (valid) => {
        if (valid) {
          if (title == "复制联想物料编码") {
            const res = await apiLenovoMaterialCopy({
              ...this.copyForm,
            });
            if (res.code == 0) {
              this.$refs.copyDialog.dialogVisible = false;
              this.onSearch();
              this.$message({ message: "复制成功", type: "success" });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 关闭复制对话框
    copyDialogClose() {
      this.$refs.copyForm.resetFields();
      this.copyForm = {};
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确认删除该记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await apiLenovoMaterialDelete({ id: row.id });
        if (res.code == 0) {
          this.onSearch();
          this.$message({ message: '删除成功', type: 'success' });
        }
      }).catch(() => {});
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.onSearch();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.onSearch();
    },
    // 表格导出
    tableExport() {
      this.$confirm(`导出数据可能需要几分钟的时间，确定导出吗？`, "导出列表", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        const res = await apiLenovoMaterialExport({
          ...this.lenovoSearchForm,
        });
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.lenovoMaterial {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
